<table mat-table [dataSource]="properties" [trackBy]="trackByPropertyKey">
  <ng-container matColumnDef="title">
    <th mat-header-cell class="group-table-header" *matHeaderCellDef>{{ tableTitle }}</th>
    <td mat-cell *matCellDef="let row">{{ row.title | translate }}</td>
  </ng-container>

  @if (columns !== '*') {
    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
        <td mat-cell *matCellDef="let row">
          @if (row.properties[column].ValueType.IsText && !row.properties[column].Items.length) {
            <app-entity-text-property
              [property]="row.properties[column]"
              [formGroup]="formGroup"
              (propertyChange)="propertyChanged(row.properties[column], $event.Value)"
            >
            </app-entity-text-property>
          }

          @if (row.properties[column].ValueType.IsNumeric && !row.properties[column].Items.length) {
            <app-entity-number-property
              [property]="row.properties[column]"
              [formGroup]="formGroup"
              [showLabel]="false"
              [showMeasurementUnit]="false"
              [showErrors]="false"
              (propertyChange)="propertyChanged(row.properties[column], $event.Value)"
            >
            </app-entity-number-property>
          }

          @if (row.properties[column].ValueType.IsBoolean) {
            <app-entity-boolean-property
              [property]="row.properties[column]"
              [formGroup]="formGroup"
              (propertyChange)="propertyChanged(row.properties[column], $event.Value)"
            >
            </app-entity-boolean-property>
          }

          @if (row.properties[column].Items.length > 0) {
            <app-entity-list-property
              [property]="row.properties[column]"
              [formGroup]="formGroup"
              [showLabel]="false"
              [showMeasurementUnit]="false"
              [showErrors]="false"
              (propertyChange)="propertyChanged(row.properties[column], $event.Value)"
            >
            </app-entity-list-property>
          }
        </td>
      </ng-container>
    }
  }

  @if (columns === '*') {
    <ng-container [matColumnDef]="'*'">
      <th mat-header-cell class="group-table-header" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        @if (row.properties['*'].ValueType.IsText && !row.properties['*'].Items.length) {
          <app-entity-text-property
            [property]="row.properties['*']"
            [formGroup]="formGroup"
            (propertyChange)="propertyChanged(row.properties['*'], $event.Value)"
          >
          </app-entity-text-property>
        }

        @if (row.properties['*'].ValueType.IsNumeric && !row.properties['*'].Items.length) {
          <app-entity-number-property
            [property]="row.properties['*']"
            [formGroup]="formGroup"
            [showLabel]="false"
            [showMeasurementUnit]="false"
            [showErrors]="false"
            (propertyChange)="propertyChanged(row.properties['*'], $event.Value)"
          >
          </app-entity-number-property>
        }

        @if (row.properties['*'].ValueType.IsBoolean) {
          <app-entity-boolean-property
            [property]="row.properties['*']"
            [formGroup]="formGroup"
            (propertyChange)="propertyChanged(row.properties['*'], $event.Value)"
          >
          </app-entity-boolean-property>
        }

        @if (row.properties['*'].Items.length > 0) {
          <app-entity-list-property
            [property]="row.properties['*']"
            [formGroup]="formGroup"
            [showLabel]="false"
            [showMeasurementUnit]="false"
            [showErrors]="false"
            (propertyChange)="propertyChanged(row.properties['*'], $event.Value)"
          >
          </app-entity-list-property>
        }
      </td>
    </ng-container>
  }

  @if (showMeasurementUnit) {
    <ng-container [matColumnDef]="'measurementUnit'">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        {{ row.measurementUnitTextId | translate }}
      </td>
    </ng-container>
  }

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr class="input-row" mat-row *matRowDef="let row; columns: tableColumns"></tr>
</table>
